import banners from './banners'
import newsletter from './newsletter'
import alerts from './alerts'
import siteMenu from './site-menu'

const marketing = {
    banners: Object.assign(banners, banners),
    newsletter: Object.assign(newsletter, newsletter),
    alerts: Object.assign(alerts, alerts),
    siteMenu: Object.assign(siteMenu, siteMenu),
}

export default marketing